// extracted by mini-css-extract-plugin
module.exports = {"link":"CorrespondingReceiptSection_link__2CVA5"};